import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

const VARIABLE_REGEX = /\{\{\s*([a-zA-Z_][\w.-]*)\s*\}\}/g;

export const variableHighlightKey = new PluginKey('variableHighlight');

const buildDecorations = doc => {
  const decorations = [];
  doc.descendants((node, pos) => {
    if (!node.isText) return;
    const re = new RegExp(VARIABLE_REGEX.source, 'g');
    [...node.text.matchAll(re)].forEach(match => {
      const from = pos + match.index;
      const to = from + match[0].length;
      decorations.push(
        Decoration.inline(from, to, {
          class: 'tiptap-variable',
        }),
      );
    });
  });
  return DecorationSet.create(doc, decorations);
};

const VariableHighlight = Extension.create({
  name: 'variableHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: variableHighlightKey,
        state: {
          init: (_, { doc }) => buildDecorations(doc),
          apply: (tr, oldSet) => (tr.docChanged ? buildDecorations(tr.doc) : oldSet),
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },
});

export default VariableHighlight;
